import React from 'react';
import { Helmet } from 'react-helmet';
import CommonPageHeader from '../../components/CommonPageHeader/CommonPageHeader';
import SickNoteArea from './SickNoteArea/SickNoteArea';
import { getFAQSchema } from './SickNoteArea/faqData';

const SickNoteLanding = () => {
  // Get the FAQ schema for structured data
  const faqSchema = getFAQSchema();

  return (
    <>
      <Helmet>
        <title>Request a Sick Note Online | South Vancouver Medical Clinic</title>
        <link rel="canonical" href="https://southvanmed.com/sicknote" />
        <meta name="description" content="Need a doctor's note for work or school? Get a legally valid sick note online for $50. Fast, secure, and doctor-issued within 1 business day. PIPA compliant." />
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      <CommonPageHeader 
        title="Request a sick note (doctor certificate) online" 
        subtitle="Sick Note"  
        pageDescription="At the South Van Medical Clinic, we offer a convenient online service for obtaining doctor's notes for work or school absences. Typically provided within 1 business day."
      />

      <SickNoteArea />
    </>
  );
};

export default SickNoteLanding;